import * as ModalTypes from '@components/App/Modal/constants'

import * as ActionTypes from '../actions'

const initialState = {
  modalType: ModalTypes.MODAL_NONE,
  dialogType: ModalTypes.MODAL_NONE,
  modalProps: {},
  dialogProps: {},
  dialogListeners: [],
  requestSignals: {
    def: null,
  },
  undo: false,
  redo: false,
  saveStatus: 'default',
  type: null,
  error: null,
  preview: {
    currentPreview: null,
    selectedPreview: null,
  },
  publishedProject: null,
  threadsPanelShown: false,
  seoPanelShow: null,
  syncStatus: 'hidden',
  locked: {},
}

export default function ui(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.SET_ERROR: {
      return {
        ...state,
        error: payload,
      }
    }

    case ActionTypes.SHOW_COMMENTS: {
      const { type } = payload

      if (type === 'block') {
        return {
          ...state,
          modalType: ModalTypes.MODAL_BLOCK,
          modalProps: {
            ...payload,
            id: payload.commentable,
          },
        }
      }

      return {
        ...state,
        modalType: ModalTypes.MODAL_BLOCK_CONTENT_VIEW,
        modalProps: {
          ...payload,
          scrolless: true,
          nodeId: payload.commentable,
        },
      }
    }

    case ActionTypes.DELETE_BLOCK:
      return state.modalType === ModalTypes.MODAL_BLOCK
        ? state.modalProps.id === payload
          ? {
              ...state,
              modalType: ModalTypes.MODAL_NONE,
              modalProps: {},
            }
          : state
        : state
    case ActionTypes.OPEN_SYMBOL:
      return {
        ...state,
        modalType: ModalTypes.MODAL_SYMBOL,
        modalProps: { ...payload },
      }
    case ActionTypes.OPEN_BLOCK:
      return {
        ...state,
        modalType: ModalTypes.MODAL_BLOCK,
        modalProps: { ...payload },
      }
    case ActionTypes.OPEN_MODAL:
      return typeof payload === 'string'
        ? {
            ...state,
            modalType: payload,
            modalProps: {},
          }
        : {
            ...state,
            modalType: payload.modalType,
            modalProps: payload.modalProps || {},
          }
    case ActionTypes.OPEN_SYSTEM_DIALOG:
      return typeof payload === 'string'
        ? {
            ...state,
            dialogType: payload,
            dialogProps: {},
            dialogListeners: [],
          }
        : {
            ...state,
            dialogType: payload.dialogType,
            dialogProps: payload.dialogProps || {},
            dialogListeners: [],
          }
    case ActionTypes.CHANGE_LOCK_MODAL: {
      return {
        ...state,
        modalProps: {
          ...state.modalProps,
          isLocked: payload.isLocked,
        },
      }
    }
    case ActionTypes.CHANGE_CONFIRM_CLOSING: {
      return {
        ...state,
        modalProps: {
          ...state.modalProps,
          confirmClosing: payload.confirmClosing,
        },
      }
    }
    case ActionTypes.SETUP_SUCCESS: {
      return {
        ...state,
        modalType: ModalTypes.MODAL_NONE,
      }
    }
    case ActionTypes.CLOSE_MODAL:
    case ActionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        modalType: ModalTypes.MODAL_NONE,
        modalProps: {},
      }
    case ActionTypes.CLOSE_SYSTEM_DIALOG:
      return { ...state, dialogType: ModalTypes.MODAL_NONE, dialogProps: {} }
    case ActionTypes.UPDATE_UI:
      return { ...state, ...payload }
    case ActionTypes.THREADS_PANEL_SET_SHOWN: {
      return {
        ...state,
        threadsPanelShown: payload,
      }
    }
    case ActionTypes.SEO_PANEL_SET_SHOW: {
      return {
        ...state,
        seoPanelShow: payload,
      }
    }
    case ActionTypes.SYNC_STATUS: {
      return {
        ...state,
        syncStatus: payload,
      }
    }
    case ActionTypes.UI_SET_LOCKS: {
      return {
        ...state,
        locked: { ...state.locked, ...payload },
      }
    }

    case ActionTypes.UI_RELEASE_LOCKS: {
      const lockedKeys = Object.keys(state.locked).filter(
        (key) => !payload.includes(key)
      )

      const locked = lockedKeys.reduce((acc, key) => {
        acc[key] = state.locked[key]
        return acc
      }, {})

      return {
        ...state,
        locked,
      }
    }
    default:
      return state
  }
}

export const openModal = (modalType, modalProps = null) => {
  const payload = !modalProps
    ? modalType
    : {
        modalType,
        modalProps,
      }

  return {
    type: ActionTypes.OPEN_MODAL,
    payload,
  }
}

export const openSystemDialog = (dialogType, dialogProps) => {
  const payload = !dialogProps
    ? dialogType
    : {
        dialogType,
        dialogProps,
      }
  return {
    type: ActionTypes.OPEN_SYSTEM_DIALOG,
    payload,
  }
}

export const changeLockModal = (isLocked) => ({
  type: ActionTypes.CHANGE_LOCK_MODAL,
  payload: {
    isLocked,
  },
})

export const changeConfirmClosing = (confirmClosing) => ({
  type: ActionTypes.CHANGE_CONFIRM_CLOSING,
  payload: {
    confirmClosing,
  },
})

export const closeModal = () => ({
  type: ActionTypes.CLOSE_MODAL,
})

export const closeSystemDialog = () => ({
  type: ActionTypes.CLOSE_SYSTEM_DIALOG,
})

export const openBlock = (payload) => ({
  type: ActionTypes.OPEN_BLOCK,
  payload,
})

export const threadsPanelShow = () => ({
  type: ActionTypes.THREADS_PANEL_SET_SHOWN,
  payload: true,
})

export const threadsPanelHide = () => ({
  type: ActionTypes.THREADS_PANEL_SET_SHOWN,
  payload: false,
})

export const seoPanelShow = (payload) => ({
  type: ActionTypes.SEO_PANEL_SET_SHOW,
  payload,
})

export const seoPanelHide = () => ({
  type: ActionTypes.SEO_PANEL_SET_SHOW,
  payload: null,
})

export const setSyncStatus = (payload) => ({
  type: ActionTypes.SYNC_STATUS,
  payload,
})

export const uiSetLocks = (payload) => ({
  type: ActionTypes.UI_SET_LOCKS,
  payload,
})

export const uiReleaseLocks = (payload) => ({
  type: ActionTypes.UI_RELEASE_LOCKS,
  payload,
})
